'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwFilterList = require('../cwfilterlist/CwFilterList');

var _CwFilterList2 = _interopRequireDefault(_CwFilterList);

var _CwButton = require('../cwbutton/CwButton');

var _CwButton2 = _interopRequireDefault(_CwButton);

var _CwDoubleFilterList = require('./CwDoubleFilterList.scss');

var _CwDoubleFilterList2 = _interopRequireDefault(_CwDoubleFilterList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwDoubleFilterList = function (_React$Component) {
  (0, _inherits3.default)(CwDoubleFilterList, _React$Component);

  function CwDoubleFilterList(props) {
    (0, _classCallCheck3.default)(this, CwDoubleFilterList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwDoubleFilterList.__proto__ || (0, _getPrototypeOf2.default)(CwDoubleFilterList)).call(this, props));

    _this.getSelectedByName = function (arr, values) {
      var results = [];

      if (typeof arr == 'undefined') {
        return results;
      }

      for (var i = 0, l = values.length; i < l; i++) {
        for (var j = 0, s = arr.length; j < s; j++) {
          if (values[i] === arr[j].name) {
            results.push(arr[j].id);
            break;
          }
        }
      }

      return results;
    };

    _this.getSelectedById = function (arr, values) {
      var results = [];

      if (typeof arr == 'undefined') {
        return results;
      }

      for (var i = 0, l = values.length; i < l; i++) {
        for (var j = 0, s = arr.length; j < s; j++) {
          if (values[i] === arr[j].id) {
            results.push(arr[j]);
            break;
          }
        }
      }

      return results.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    };

    _this.getNonSelectedById = function (arr, values) {
      var selected = _this.getSelectedById(arr, values);
      var unselected = [];

      if (typeof arr == 'undefined') {
        return unselected;
      }

      unselected = unselected.concat(arr);
      for (var i = 0, l = selected.length; i < l; i++) {
        var index = unselected.indexOf(selected[i]);
        unselected.splice(index, 1);
      }

      return unselected.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    };

    _this.getIdsFromObjects = function (arr) {
      var result = [];

      for (var i = 0, l = arr.length; i < l; i++) {
        result.push(arr[i].id);
      }

      return result;
    };

    _this.addAllToSelection = function () {
      var newValue = _this.getIdsFromObjects(_this.props.items ? _this.props.items : []);
      _this.props.onChange(newValue);
    };

    _this.addSelectedToSelection = function () {
      var previousSelection = _this.props.value ? _this.props.value : [];
      var selected = _this.state.selectedAItems;
      var newValue = [];
      newValue = newValue.concat(previousSelection);
      newValue = newValue.concat(selected);

      _this.props.onChange(newValue);
    };

    _this.removeSelectedFromSelection = function () {
      var previousSelection = _this.props.value ? _this.props.value : [];
      var selected = _this.state.selectedBItems;
      var newValue = [];
      newValue = newValue.concat(previousSelection);
      for (var i = 0, l = selected.length; i < l; i++) {
        var index = newValue.indexOf(selected[i]);
        newValue.splice(index, 1);
      }

      _this.props.onChange(newValue);
    };

    _this.removeAllFromSelection = function () {
      var newValue = [];
      _this.props.onChange(newValue);
    };

    _this.handleListBChange = function (event) {
      var selection = event ? event : [];
      var intArray = [];
      for (var i = 0, l = selection.length; i < l; i++) {
        intArray.push(parseInt(selection[i], 10));
      }
      _this.setState({ selectedBItems: intArray });
      if (_this.props.onRightSelected) {
        _this.props.onRightSelected(event);
      }
    };

    _this.handleListBBlur = function () {
      if (_this.props.onRightBlur) {
        _this.props.onRightBlur();
      }
    };

    _this.handleListBFocus = function () {
      if (_this.props.onRightFocus) {
        _this.props.onRightFocus();
      }
    };

    _this.handleListAChange = function (event) {
      var selection = event ? event : [];
      var intArray = [];
      for (var i = 0, l = selection.length; i < l; i++) {
        intArray.push(parseInt(selection[i], 10));
      }

      _this.setState({ selectedAItems: intArray });
      if (_this.props.onLeftSelected) {
        _this.props.onLeftSelected(event);
      }
    };

    _this.state = {
      selectedAItems: [],
      selectedBItems: []
    };
    return _this;
  }

  (0, _createClass3.default)(CwDoubleFilterList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // NOTE: Perform any magic you need when the filterlist re-mounts (i.e. after pod collapses then re-expands)
      if (this.props.onLoad) {
        this.props.onLoad();
      }
    }

    /**
     * Adds everything in list A to list B
     * The list updates based on what the value is set. So we set the value to
     * all objects and what happens is list A gets an empty array and list B
     * gets an array of all objects
     */


    /**
     * Add the selected values in list A (left list) to list B (right list)
     * Updates the value so that when the state is updated both list gets a new
     * filtered list
     */


    /**
     * Remove the selected values in list B (right side) and adds it to
     * List A (left side) 
     * Updates the value so that when the state is updated both list gets a new
     * filtered list
     */


    /**
     * Remove everything in list B (right side) and adds it to 
     * List A (left side)
     * Setting the value to an empty [] will filter it so everything
     * is displayed in List A
     */


    /**
     * Updated the state with the selected options in list B (right side)
     */


    /**
     * handler for when the right-hand-side list loses focus
     */

    /**
     * handler for when the right-hand-side receives focus
     */


    /**
     * Update the state with the selected options in list A (left side)
     */

  }, {
    key: 'render',
    value: function render() {
      var filter = this.props.value ? this.props.value : [];
      var _props = this.props,
          items = _props.items,
          includeFilter = _props.includeFilter,
          disabled = _props.disabled,
          leftListLabel = _props.leftListLabel,
          rightListLabel = _props.rightListLabel,
          leftFilter = _props.leftFilter,
          rightFilter = _props.rightFilter,
          mapKey = _props.mapKey,
          size = _props.size,
          placeholder = _props.placeholder;

      var selectedAItems = this.state.selectedAItems ? this.state.selectedAItems : [];
      var selectedBItems = this.state.selectedBItems ? this.state.selectedBItems : [];

      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId, className: _CwDoubleFilterList2.default.wrap },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_CwFilterList2.default, {
            options: filter.length > 0 ? this.getNonSelectedById(items, filter) : items,
            value: selectedAItems,
            onChange: this.handleListAChange,
            cwId: 'flistA' + this.props.cwId,
            listHeader: leftListLabel,
            placeholder: placeholder,
            size: size,
            defaultFilter: leftFilter,
            includeFilter: includeFilter,
            mapKey: mapKey,
            disabled: disabled,
            allowMultiSelect: this.props.leftAllowMultiSelect
          })
        ),
        _react2.default.createElement(
          'div',
          { className: _CwDoubleFilterList2.default.buttons },
          _react2.default.createElement(_CwButton2.default, {
            value: ">>",
            onClick: this.addAllToSelection,
            disabled: disabled
          }),
          _react2.default.createElement(_CwButton2.default, {
            value: ">",
            onClick: this.addSelectedToSelection,
            disabled: disabled
          }),
          _react2.default.createElement(_CwButton2.default, {
            value: "<",
            onClick: this.removeSelectedFromSelection,
            disabled: disabled
          }),
          _react2.default.createElement(_CwButton2.default, {
            value: "<<",
            onClick: this.removeAllFromSelection,
            disabled: disabled
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_CwFilterList2.default, {
            options: filter.length > 0 ? this.getSelectedById(items, filter) : [],
            value: selectedBItems,
            onChange: this.handleListBChange,
            onBlur: this.handleListBBlur,
            onFocus: this.handleListBFocus,
            cwId: 'flistB' + this.props.cwId,
            listHeader: rightListLabel,
            placeholder: placeholder,
            size: size,
            defaultFilter: rightFilter,
            includeFilter: includeFilter,
            mapKey: mapKey,
            disabled: disabled,
            allowMultiSelect: this.props.rightAllowMultiSelect
          })
        )
      );
    }
  }]);
  return CwDoubleFilterList;
}(_react2.default.Component);

CwDoubleFilterList.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: _propTypes2.default.func,
  /**
   * List of all items unfiltered. Must contain at least "id" and "name" fields.
   */
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.number,
    name: _propTypes2.default.string
  })),
  /**
   * Path in screenData where the List's value will be stored and retrieved
   */
  value: _propTypes2.default.arrayOf(_propTypes2.default.number),
  /**
   * Label for the left list box
   */
  leftListLabel: _propTypes2.default.string,
  /**
   * Label for the right list box
   */
  rightListLabel: _propTypes2.default.string,
  /**
   * Default filter for left list
   */
  leftFilter: _propTypes2.default.string,
  /**
   * Default filter for right list
   */
  rightFilter: _propTypes2.default.string,
  /**
   * Boolean to render the filter or not
   */
  includeFilter: _propTypes2.default.bool,
  /**
   * Key for the filter map lookup used to filter the list by property
   */
  mapKey: _propTypes2.default.string,
  /**
   * Used to disable the entire widget (lists, filters and buttons)
   */
  disabled: _propTypes2.default.bool,
  /**
   * Callback function that is fired when selection in the left filter list changes
   */
  onLeftSelected: _propTypes2.default.func,
  /**
   * Callback function that is fired when selection in the right filter list changes
   */
  onRightSelected: _propTypes2.default.func,
  /**
   * Allows the user to select multiple items at the same time in the left flist
   */
  leftAllowMultiSelect: _propTypes2.default.bool,
  /**
   * Allows the user to select multiple items at the same time in the right list
   */
  rightAllowMultiSelect: _propTypes2.default.bool,
  /**
   * handler for when the right-hand-side list loses focus
   */
  onRightBlur: _propTypes2.default.func,
  /**
   * handler for when the right-hand-side list receives focus
   */
  onRightFocus: _propTypes2.default.func
};

CwDoubleFilterList.defaultProps = {
  leftListLabel: 'List A',
  rightListLabel: 'List B',
  leftAllowMultiSelect: true,
  rightAllowMultiSelect: true
};

exports.default = CwDoubleFilterList;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdoublefilterlist/CwDoubleFilterList.js
// module id = 832
// module chunks = 10